import React from 'react';
import cx from 'classnames';

import { useLabel } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const statusesList = ['win', 'lose', 'void', 'close', 'half lose', 'half win', 'unspecified'];

const DetailsOutcomeStatus = ({ status }) => {
  const translatedStatus = useLabel(status);
  const statusTranscription = translatedStatus[0];
  const className = status.split(' ').join('_');
  return (
    <div className={cx('status-item', className)} key={status}>
      <abbr className={cx('status-transcription', className)} title={translatedStatus}>
        {statusTranscription}
      </abbr>
      -
      <Label className="status-name" message={status} />
    </div>
  );
};

const DetailsOutcomeStatusesTranscription = () => {
  return (
    <div className="statuses-transcription">
      <Icon className="status-info" height={22} name="info" width={22} />
      <div className="status-items">
        {statusesList.map(status => (
          <DetailsOutcomeStatus key={status} status={status} />
        ))}
      </div>
    </div>
  );
};

export default DetailsOutcomeStatusesTranscription;
